import { DATE_FORMAT_OMM } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { format } from 'date-fns';

export const getAvailabilityTitle = (
  isDeliveryEnabled: boolean,
  isPickUpEnabled: boolean
) => {
  return isDeliveryEnabled && !isPickUpEnabled
    ? 'PDP_AVAILABLE_TO_SHIP'
    : 'AVAILABLE_PICKUP';
};

export const getAvailabilityPickupText = (
  isDeliveryEnabled: boolean,
  isPickUpEnabled: boolean
) => {
  return isDeliveryEnabled && isPickUpEnabled
    ? 'PDP_DELIVERY_OPTIONS_AVAILABLE'
    : null;
};

export const getHoseAssemblyDetails = (hoseLabel: string) => {
  const hoseDetails = hoseLabel || 'HOSE_DEFAULT_MESSAGE';
  return hoseDetails;
};

export const shouldShowContactDealer = (availabilityInformation = []) => {
  return availabilityInformation.some(
    ({ quantityAvailable, showContactDealerPopUp }) =>
      !quantityAvailable && showContactDealerPopUp
  );
};

export const getFormattedDate = (
  date,
  locale,
  dealerDateFormat = DATE_FORMAT_OMM
) => {
  const d = new Date(date);
  return format(d, dealerDateFormat, locale);
};
